import React from "react";
import { Link } from "react-router-dom";

const HomeAbout = () => {
    return (
        <div className="container-fluid">
            <div className="py-4 text-light">
                <h2 className=" fw-bolder border-bottom border-3 border-danger d-inline">
                    Who I am?
                </h2>
            </div>
            <div className="container mt-5">
                <div className="row g-4 justify-content-center align-items-center">
                    <div className="col-md-6 col-sm-12 m-2">
                        <div className="bg-dark pb-0 shadow-lg">
                            <img
                                className="img-fluid border-bottom"
                                src="https://i.ibb.co/PDZqbHm/Abstract-form-of-fluid-1.png"
                                alt="my_pic"
                            />
                        </div>
                    </div>
                    <div className="text-start col-md-5 col-sm-12 m-2">
                        <p className="fs-5 mt-0">
                            I'm Naimur Rahman. I'm a MERN Stack web developer. I
                            born in and grow from Bangladesh.
                        </p>
                        <p>
                            I am a JavaScript-based developer with experience
                            developing feedback projects with node and server
                            with Express. My main experience is creating MERN
                            stack development. But I also have knowledge of
                            design, which is why creating a modern website
                            requires a combination of interactivity and server
                            technology. HTML and CSS used for the template,
                            ReactJS and familiar tools used for front-end,
                            NodeJS, ExpressJS for server-side, and I feel
                            comfortable creating web applications using MongoDB
                            for data storage.
                        </p>
                    </div>
                </div>
                <div className="pb-4">
                    <Link to="/aboutme">
                        <button className="btn btn-info rounded-pill">
                            Read more <i className="fas fa-info-circle" />
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default HomeAbout;
